<div class="w-full h-full flex flex-col items-center justify-center gap-4">
  @if (error()) {
    <p class="text-red-600 text-sm text-center px-4">{{ error() }}</p>
    <a routerLink="/" class="text-primary text-sm underline mt-2">Go to homepage</a>
  } @else {
    <p-progressSpinner ariaLabel="Redirecting to checkout"/>
    <p class="text-surface-500 text-sm">Setting up your checkout...</p>
  }
</div>
